import { z } from "@/zod";

export const DATE_FORMAT_DATE = "date";
export const DATE_FORMAT_DATE_TIME = "datehour";

export const DATE_FORMAT = [DATE_FORMAT_DATE, DATE_FORMAT_DATE_TIME] as const;

export default z.enum(DATE_FORMAT);
